import styled, { css } from "styled-components";

export const CustomerShell = styled.div`
  min-height: 100vh;
  background:
    radial-gradient(circle at 100% 0%, rgba(209, 225, 214, 0.75), transparent 34rem),
    #f5f4ee;
  color: #19221d;
  padding-bottom: calc(88px + env(safe-area-inset-bottom));
`;

export const CustomerHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px max(18px, calc((100vw - 960px) / 2));
  background: rgba(250, 250, 246, 0.94);
  border-bottom: 1px solid #d8ded8;
  backdrop-filter: blur(14px);

  > a:first-child {
    min-height: 44px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: inherit;
    text-decoration: none;
  }

  @media (max-width: 996px) {
    padding-inline: 18px;
  }
`;

export const CustomerMark = styled.span`
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  background: #1f3c2e;
  color: white;
  font-family: ${({ theme }) => theme.display};
  font-size: 20px;
`;

export const CustomerBrand = styled.span`
  display: grid;
  line-height: 1.15;

  strong {
    font-size: 15px;
  }

  small {
    margin-top: 3px;
    color: #5b685f;
    font-size: 12px;
  }
`;

export const HeaderLinks = styled.nav`
  display: flex;
  align-items: center;
  gap: 4px;

  a {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    padding: 0 10px;
    border-radius: 8px;
    color: #4b5c52;
    font-size: 13px;
    font-weight: 650;
    text-decoration: none;
  }

  a:hover {
    background: #e9eee9;
    color: #1d392b;
  }

  @media (max-width: 540px) {
    display: none;
  }
`;

export const CustomerMain = styled.main`
  width: min(960px, calc(100% - 36px));
  margin: 0 auto;
  padding: 34px 0 24px;

  @media (max-width: 600px) {
    padding-top: 24px;
  }
`;

export const CustomerLoading = styled.main`
  min-height: 65vh;
  display: grid;
  place-items: center;
  padding: 24px;
  text-align: center;

  div {
    max-width: 360px;
  }

  span {
    width: 38px;
    height: 38px;
    display: inline-grid;
    place-items: center;
    border-radius: 50%;
    background: #dce9df;
    color: #244936;
    font-weight: 800;
  }

  h1 {
    margin: 16px 0 6px;
    font-family: ${({ theme }) => theme.display};
    font-size: 25px;
  }

  p {
    margin: 0;
    color: #56645b;
  }

  button,
  a {
    min-height: 44px;
    margin-top: 18px;
  }
`;

export const CustomerLoginForm = styled.form`
  display: grid;
  gap: 9px;
  margin-top: 20px;
  text-align: left;

  label {
    color: #34433a;
    font-size: 14px;
    font-weight: 750;
  }

  input {
    width: 100%;
    min-height: 48px;
    box-sizing: border-box;
    border: 1px solid #acbbb0;
    border-radius: 10px;
    padding: 0 13px;
    background: white;
    color: #19221d;
    font: inherit;
    font-size: 16px;
  }

  button {
    width: 100%;
    min-height: 48px;
    margin-top: 3px;
    border: 0;
    border-radius: 10px;
    background: #1f3c2e;
    color: white;
    cursor: pointer;
    font: inherit;
    font-weight: 800;
  }

  button:disabled,
  input:disabled {
    cursor: wait;
    opacity: 0.7;
  }
`;

export const CustomerHero = styled.section`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 26px;

  > div:first-child {
    max-width: 650px;
  }

  h1 {
    margin: 6px 0 8px;
    font-family: ${({ theme }) => theme.display};
    font-size: clamp(32px, 5vw, 52px);
    font-weight: 560;
    line-height: 1.03;
    letter-spacing: -0.035em;
  }

  p {
    margin: 0;
    color: #526158;
    font-size: 16px;
  }

  @media (max-width: 700px) {
    display: grid;
  }
`;

export const Eyebrow = styled.p`
  color: #3b6750 !important;
  font-size: 12px !important;
  font-weight: 800;
  letter-spacing: 0.11em;
  text-transform: uppercase;
`;

export const OwnerControl = styled.aside`
  min-width: 230px;
  padding: 13px 15px;
  border: 1px solid #cbd8ce;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.65);

  strong {
    display: block;
    font-size: 13px;
  }

  span {
    display: block;
    margin-top: 3px;
    color: #526158;
    font-size: 12px;
  }
`;

export const CustomerGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(260px, 0.75fr);
  gap: 18px;
  align-items: start;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const CustomerPanel = styled.section`
  border: 1px solid #d9dfda;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 50px rgba(28, 43, 33, 0.055);
  padding: 20px;

  h2 {
    margin: 0;
    font-size: 19px;
  }

  > p {
    margin: 6px 0 0;
    color: #58665d;
    font-size: 14px;
  }

  & + & {
    margin-top: 18px;
  }
`;

export const ProgressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: start;

  strong {
    font-family: ${({ theme }) => theme.display};
    color: #244936;
    font-size: 30px;
    font-weight: 550;
  }
`;

export const ProgressTrack = styled.div`
  height: 8px;
  margin-top: 16px;
  overflow: hidden;
  border-radius: 999px;
  background: #e5eae6;

  i {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: #397250;
  }
`;

export const PlanList = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 18px;
`;

const planTone = {
  setup: "#426551",
  revenue: "#775e2a",
  efficiency: "#3d6172",
};

export const PlanCard = styled.article<{
  $kind: "setup" | "revenue" | "efficiency";
}>`
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  gap: 13px;
  align-items: start;
  padding: 16px;
  border: 1px solid #dce2dd;
  border-radius: 13px;
  background: #fbfcfa;

  > span {
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: ${({ $kind }) => `${planTone[$kind]}18`};
    color: ${({ $kind }) => planTone[$kind]};
    font-weight: 850;
  }

  h3 {
    margin: 0;
    font-size: 15px;
  }

  p {
    margin: 5px 0 0;
    color: #5a675f;
    font-size: 13px;
  }

  button {
    min-height: 44px;
    border: 0;
    border-radius: 9px;
    padding: 0 13px;
    background: #e6eee8;
    color: #294c39;
    cursor: pointer;
    font-size: 12px;
    font-weight: 750;
  }

  @media (max-width: 560px) {
    grid-template-columns: 38px minmax(0, 1fr);

    button {
      grid-column: 1 / -1;
      width: 100%;
    }
  }
`;

export const ServiceTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;

  span {
    padding: 7px 10px;
    border-radius: 999px;
    background: #e9efea;
    color: #304b3c;
    font-size: 12px;
    font-weight: 650;
  }
`;

export const EmptyEvidence = styled.div`
  margin-top: 16px;
  padding: 16px;
  border: 1px dashed #c9d3cb;
  border-radius: 12px;
  background: #fafbf9;

  strong {
    display: block;
    font-size: 14px;
  }

  p {
    margin: 5px 0 0;
    color: #5b685f;
    font-size: 13px;
  }
`;

export const ExtraTasks = styled.p`
  margin: 14px 0 0 !important;
  color: #536159;
  font-size: 13px !important;
  text-align: center;
`;

export const SetupIntro = styled.div`
  max-width: 680px;
  margin-bottom: 22px;

  h1 {
    margin: 6px 0 8px;
    font-family: ${({ theme }) => theme.display};
    font-size: clamp(30px, 5vw, 46px);
    line-height: 1.08;
  }

  p {
    margin: 0;
    color: #526158;
  }
`;

export const SetupForm = styled.form`
  display: grid;
  gap: 18px;

  fieldset {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    margin: 0;
    padding: 20px;
    border: 1px solid #d9dfda;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 18px 50px rgba(28, 43, 33, 0.045);
  }

  legend {
    padding: 0 7px;
    color: #254532;
    font-size: 15px;
    font-weight: 800;
  }

  label {
    display: grid;
    gap: 6px;
    color: #34433a;
    font-size: 13px;
    font-weight: 700;
  }

  label span {
    color: #657168;
    font-size: 12px;
    font-weight: 500;
  }

  input,
  textarea,
  select {
    width: 100%;
    min-height: 46px;
    border: 1px solid #bec9c1;
    border-radius: 9px;
    padding: 10px 11px;
    background: white;
    color: #18221c;
    font: inherit;
    font-size: 16px;
  }

  textarea {
    min-height: 112px;
    resize: vertical;
  }

  @media (max-width: 640px) {
    fieldset {
      grid-template-columns: 1fr;
      padding: 17px;
    }
  }
`;

export const WideField = styled.label`
  grid-column: 1 / -1;
`;

export const FormMessage = styled.div<{ $error?: boolean }>`
  padding: 12px 14px;
  border: 1px solid ${({ $error }) => ($error ? "#d8aaa5" : "#b8d3c0")};
  border-radius: 10px;
  background: ${({ $error }) => ($error ? "#fff1ef" : "#edf7f0")};
  color: ${({ $error }) => ($error ? "#812f28" : "#245b37")};
  font-size: 14px;
`;

export const SaveBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 15px;
  border: 1px solid #cdd7cf;
  border-radius: 13px;
  background: rgba(250, 251, 248, 0.96);
  box-shadow: 0 15px 38px rgba(25, 44, 33, 0.12);
  backdrop-filter: blur(14px);

  p {
    margin: 0;
    color: #536159;
    font-size: 13px;
  }

  button {
    min-width: 150px;
    min-height: 46px;
    border: 0;
    border-radius: 9px;
    background: #244c37;
    color: white;
    cursor: pointer;
    font-weight: 800;
  }

  @media (max-width: 540px) {
    align-items: stretch;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

export const CustomerNav = styled.nav`
  position: fixed;
  inset: auto 0 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 9px 18px calc(9px + env(safe-area-inset-bottom));
  border-top: 1px solid #d4dcd6;
  background: rgba(251, 251, 248, 0.96);
  backdrop-filter: blur(16px);

  a {
    min-width: 145px;
    min-height: 50px;
    display: grid;
    place-items: center;
    border-radius: 11px;
    color: #59675f;
    font-size: 13px;
    font-weight: 750;
    text-decoration: none;
  }

  a[aria-current="page"] {
    background: #deebe1;
    color: #244a36;
  }

  @media (max-width: 420px) {
    a {
      flex: 1;
      min-width: 0;
    }
  }
`;

export const InlineButton = styled.button`
  min-height: 44px;
  border: 1px solid #b9c9bd;
  border-radius: 9px;
  padding: 0 14px;
  background: white;
  color: #264b37;
  cursor: pointer;
  font-weight: 750;
`;

export const MoneyValue = styled.strong`
  font-variant-numeric: tabular-nums;
`;

export const OnlyDesktop = styled.span`
  @media (max-width: 540px) {
    display: none;
  }
`;

export const screenReaderOnly = css`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`;
